/* tslint:disable */
/* eslint-disable */
/**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    EvmNft,
    EvmNftFromJSON,
    EvmNftFromJSONTyped,
    EvmNftToJSON,
    EvmNftListAllOf,
    EvmNftListAllOfFromJSON,
    EvmNftListAllOfFromJSONTyped,
    EvmNftListAllOfToJSON,
    List,
    ListFromJSON,
    ListFromJSONTyped,
    ListToJSON,
} from './';

/**
 * 
 * @export
 * @interface EvmNftList
 */
export interface EvmNftList {
    /**
     * The total number of records that match the query, i.e. the number of records
     * the query would return with limit=infinity.
     * @type {number}
     * @memberof EvmNftList
     */
    total_count: number;
    /**
     * Whether total_count is clipped for performance reasons.
     * @type {boolean}
     * @memberof EvmNftList
     */
    is_total_count_clipped: boolean;
    /**
     * A list of L2 EVM NFT (ERC-721, ...) instances.
     * @type {Array<EvmNft>}
     * @memberof EvmNftList
     */
    evm_nfts: Array<EvmNft>;
}

export function EvmNftListFromJSON(json: any): EvmNftList {
    return EvmNftListFromJSONTyped(json, false);
}

export function EvmNftListFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvmNftList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total_count': json['total_count'],
        'is_total_count_clipped': json['is_total_count_clipped'],
        'evm_nfts': ((json['evm_nfts'] as Array<any>).map(EvmNftFromJSON)),
    };
}

export function EvmNftListToJSON(value?: EvmNftList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_count': value.total_count,
        'is_total_count_clipped': value.is_total_count_clipped,
        'evm_nfts': ((value.evm_nfts as Array<any>).map(EvmNftToJSON)),
    };
}


